import {Values} from '@wix/devzai-utils-common';

export const BymoTemplateSpeedDialInputType = {
    PinInput: 'PinInput',
    TextBox: 'TextBox'
} as const;
export type BymoTemplateSpeedDialInputType = Values<typeof BymoTemplateSpeedDialInputType>;

export const BymoTemplateSpeedDialAutoComplete = {
    Hidden: 'Hidden',
    OnInputFocus: 'OnInputFocus',
    OnInputSearch: 'OnInputSearch'
} as const;
export type BymoTemplateSpeedDialAutoComplete = Values<typeof BymoTemplateSpeedDialAutoComplete>;

export const BymoTemplateSpeedDialActionsListAppearance = {
    Visible: 'Visible',
    Hidden: 'Hidden',
    Collapsed: 'Collapsed'
} as const;
export type BymoTemplateSpeedDialActionsListAppearance = Values<typeof BymoTemplateSpeedDialActionsListAppearance>;

export const BymoTemplateSpeedDialSearchAppearance = {
    Default: 'Default',
    Visible: 'Visible',
    Hidden: 'Hidden',
} as const;
export type BymoTemplateSpeedDialSearchAppearance = Values<typeof BymoTemplateSpeedDialSearchAppearance>;

export const BymoTemplateSpeedDialHeaderAppearance = {
    Default: 'Default',
    Hidden: 'Hidden',
} as const;
export type BymoTemplateSpeedDialHeaderAppearance = Values<typeof BymoTemplateSpeedDialHeaderAppearance>;

export const BymoTemplateSpeedDialSocialLinksAppearance = {
    Default: 'Default',
    Visible: 'Visible',
    Hidden: 'Hidden'
} as const;
export type BymoTemplateSpeedDialSocialLinksAppearance = Values<typeof BymoTemplateSpeedDialSocialLinksAppearance>;

export const BymoTemplateSpeedDialMenuAppearance = {
    Default: 'Default',
    Visible: 'Visible',
    Hidden: 'Hidden',
} as const;
export type BymoTemplateSpeedDialMenuAppearance = Values<typeof BymoTemplateSpeedDialMenuAppearance>;